import { render, staticRenderFns } from "./age-gate-new-design-form.vue?vue&type=template&id=c40d32c4"
import script from "./age-gate-new-design-form.vue?vue&type=script&lang=js"
export * from "./age-gate-new-design-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports